import { Component, OnInit, SecurityContext } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'page-license',
  templateUrl: 'license.html',
})
export class LicensePage implements OnInit {

  html: any = ``;

  constructor(public navCtrl: NavController, public navParams: NavParams, private sanitizer: DomSanitizer) {
  }

  ionViewDidLoad() {
    this.html = `
    
    `;
  }

  ngOnInit(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/license/license.ts